<template>
  <div>
    <Modal v-model="uploadModal" width="600" footer-hide>
      <p slot="header" class="text-center">导入文件</p>
      <Upload
        ref="upload"
        type="drag"
        name="excelFile"
        :action="uploadUrl"
        :headers="uploadHeaders"
        :data="{remark}"
        :format="['xlsx', 'xls']"
        :on-success="onUploadSuccess"
        accept=".xlsx,.xls"
      >
        <div style="padding: 20px 0">
          <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
          <p>点击选择一个Excel文件上传</p>
        </div>
      </Upload>
      <div class="m-b-10">提示：若没有模板，请点击<a href="https://file.oohforce.com/20250819/12426936dfcbf409901cc1c7469e174f.xls">下载模板</a></div>
    </Modal>
  </div>
</template>

<script>
import { getStorage } from '@/utils/storage'
export default {
  data () {
    return {
      uploadUrl: `${process.env.VUE_APP_API_URL_V2}/ooh-msp/v1/playList/importExcel`,
      uploadHeaders: {
        'ooh-auth': getStorage('ooh-token')
      },
      uploadModal: false
    }
  },
  methods: {
    show () {
      this.remark = ''
      this.uploadModal = true
    },
    onUploadSuccess (res, file) {
      if (res && res.success) {
        this.uploadModal = false
        this.$emit('onSuccess')
        this.$Notice.success({ desc: '导入成功' })
      } else {
        this.$Notice.error({ desc: '导入失败' })
      }
      this.$refs.upload.clearFiles()
    }
  }
}
</script>
